<div class="page-loader" id="page-loader">
    <div>
        <div class="icon ion-spin"></div>
        <p>loading</p>
    </div>
</div>